import { ChartColumnIcon, TrophyIcon } from "lucide-react";

import { Row } from "@/components";
import { LeaderboardSettingsPopover } from "@/components/leaderboard";
import { Button } from "@/components/ui/button";

export const LeaderboardViewControls = ({
  isTrophyCase,
  onToggleView,
}: {
  isTrophyCase: boolean;
  onToggleView: () => void;
}) => {
  /* Render */
  const render = () => {
    return (
      <Row className="absolute right-4 top-4 z-30 items-center gap-1 rounded-xl border border-white/15 bg-slate-950/90 p-1 shadow-lg">
        <Button
          variant="ghost"
          size="sm"
          className="h-8 gap-2 px-3 text-xs font-medium text-slate-100 hover:bg-white/10 hover:text-white"
          onClick={onToggleView}
        >
          {isTrophyCase ? (
            <ChartColumnIcon className="h-4 w-4" />
          ) : (
            <TrophyIcon className="h-4 w-4" />
          )}
          {isTrophyCase ? "Leaderboard" : "Trophy case"}
        </Button>
        <LeaderboardSettingsPopover isDark />
      </Row>
    );
  };

  return render();
};
